export default "__VITE_ASSET__BYXbQOjT__"